<template>
  <div class="article">
    <bread-crumb></bread-crumb>
    <div class="wrap">
      <audit-info
        actionType="8"
        :contentId="form.contentId"
        :contentName="form.contentName"
      />
      <div class="c-title-wrap">
        <p class="c-title">基本内容</p>
      </div>
      <contentAlias-Names :aliasName.sync="form.contentAliasNames" />
      <!--      选择疾病-->
      <SelectDisease
        ref="selectDiseaseRef"
        :contentId="form.contentId"
        :functionIds="{
          getRemote: 'health_cmp_pageDiseaseInfoByParam',
          validDiseaseRel: 'health_cmp_biz_manValidDiseaseRel',
        }"
      />
      <!--      传染病-->
      <infectious-mark :infectiousMark.sync="infectiousMark" />
      <!--建议科室-->
      <Department
        ref="departmentRef"
        :departmentList="departmentList"
        :selectedDeparttId.sync="selectedDeparttId"
      />
      <!-- 关联疾病 -->
      <contentLabel-cp
        :data="form.contentRelations"
        @changeDiseaseLabels="changeDiseaseLabels"
        :is-show-disease="isShowDisease"
        :functionIds="{ queryContents: 'health_cmp_queryContents' }"
      />
      <div
        class="content-item flex"
        style="position: relative"
        v-for="(item, index) in paragraphList"
        :key="index"
      >
        <p class="content-item-label">
          <span class="red">*</span>{{ item.desc }}
        </p>
        <c-editor
          :content="item.content || ''"
          :index="index"
          @editorReady="editorReady"
          :ref="'editor' + index"
          @blurEditorEvent="blurEditorEvent"
        >
        </c-editor>
      </div>
      <!--标签-->
      <content-label
        ref="contentLabelref"
        :functionIds="{
          listTenantContentLabels: 'health_cmp_biz_pageAuditLabels',
        }"
        @checkArticleLabel="checkArticleLabel"
      />
      <!--关键词-->
      <keywords ref="keywordsref" />
      <!--      编审医生-->
      <write-doctor
        :isFlag="true"
        :flag="true"
        :writeDoctor.sync="doctor"
        :writeOptions="doctorOptions"
        :write_doctor_loading="search_doctor_loading"
        @write_remoteMethod="doctor_remoteMethod"
        @writeChange="writeChange"
      />
    </div>
    <div class="finish-btns">
      <el-button
        type="primary"
        @click="manOrUpdateDiseaseInfo(2, 'through')"
        v-if="auditInfoShow == 2"
        ><span>通过</span></el-button
      >
      <el-button @click="rejectClick" v-if="auditInfoShow == 2">
        <span>驳回</span>
      </el-button>
      <el-button
        @click="manOrUpdateDiseaseInfo(1, 'save')"
        v-if="auditInfoShow == 2 ? false : auditInfoShow == 3 ? false : true"
      >
        <span>保存</span>
      </el-button>
      <el-button
        @click="manOrUpdateDiseaseInfo(2, 'manSubmit')"
        v-if="auditInfoShow !== 2"
      >
        <span>提交</span>
      </el-button>
      <el-button @click="manOrUpdateDiseaseInfo(0, 'manPreview')">
        <span>预览</span>
      </el-button>
    </div>
    <!-- ===================== 预览弹窗 ====================== -->
    <preview-modal
      :mUrl.sync="mUrl"
      :dialogPreVisible.sync="dialogPreVisible"
      :qrCode="qrCode"
    />

    <!-- ===================== 驳回弹窗 ====================== -->
    <reject-modal
      :rejectForm.sync="rejectForm"
      @rejectClickHandler="rejectClickHandler"
    />

    <modal
      :isShow.sync="deleteForm.deleteDialog"
      title="删除"
      :isShowBtn="deleteForm.isShowBtn"
      :btnText="deleteForm.btnText"
      @clickHandler="deleteClickHandler"
    >
      <div class="dialogVal">需要删除所有疾病百科信息吗？</div>
    </modal>

    <modal
      :isShow.sync="reset_Diseases"
      title="更换疾病名称"
      :btnText="[]"
      :isShowBtn="[]"
      :width="'400px'"
      @clickHandler="repealclickHandler"
    >
      <div class="dialogVal">更改疾病将清空已填疾病的所有内容，是否继续?</div>
    </modal>
  </div>
</template>
<script>
import breadCrumb from "@/components/breadCrumb";
import modal from "@/components/modal";
import CEditor from "@/components/editor/CEditor";
import contentLabelCp from "@/components/tag/contentLabelCp";
import PreviewModal from "@/components/pop/PreviewModal";
import RejectModal from "@/components/pop/RejectModal";
import contentAliasNames from "@/components/input/contentAliasNames";
import Department from "@/components/select/Department";
import Keywords from "@/components/input/Keywords";
import SelectDisease from "@/components/select/SelectDisease";
import WriteDoctor from "@/components/select/WriteDoctor";
import ContentLabel from "@/components/tag/ContentLabel";
import AuditInfo from "@/components/customize/AuditInfoBaike";
import InfectiousMark from "@/components/radio/InfectiousMark";
import { getQRCode } from "@/utils/tools";
import { request } from "@/utils/axios";

import utils from "../../../../utils";
const baseUrl = process.env.VUE_APP_BASEURL;

export default {
  data() {
    return {
      // 失去焦点编辑器保存提示成功时间，定时清除提示
      tipTimeout: null,
      //疾病搜索
      loading: false,
      diseaseInfoOptions: [],
      //结束疾病搜索
      reset_Diseases: false, // 修改关联疾病名称
      //科室
      departmentList: [],
      selectedDeparttId: [],
      //结束科室
      paragraphList: [], // 段落
      editorList: {},
      //结束编辑器相关
      // 编审医生
      search_doctor_loading: false,
      doctorOptions: [],
      doctor: "",
      actionType: "",
      user_identity: 0, // 身份信息
      infectiousMark: "", // 是否传染病
      baseUrl,
      // 疾病百科信息集合
      form: {
        contentId: undefined, // 内容基本信息id
        tenantId: Number(this.$commonJs.getTenantId()), // 租户id
        contentName: "", // 内容名称
        aliasName: "", // 别名
        contentAliasNames: [],
        englishName: undefined, // 英文名
        pinyinFirstLetter: undefined, // 拼音首字母
        diseaseInfo: {}, // 是否传染病
        contentType: undefined, // 疾病类型 默认8疾病百科 9疾病百科
        contentRelations: [], // 关联的其他内容 仅需要id和type
        contentStatus: null, // 内容状态 1 上线 2下线
        auditInfo: {}, // 审核信息
        contentLabels: [], // 标签信息
        contentParagraphs: [], // 段落信息
        contentUsers: [], // 内容关联的用户
        keywordInfos: [], // 内容关键词
        bodyParts: [], // 身体部位
        doctorInfos: [], // 关联的医生
        // editreviewType:null, // 编审类型 1 平台医生 2 黄页医生
        contentAuditStatus: 1, // 内容审核状态1草稿、2待审核、3审核通过、4驳回
        departments: [], // 科室信息
        contentDiseases: [], //绑定疾病id
      },
      isShowBtn: [false, false],
      dialogPreVisible: false,
      rejectForm: {
        rejectlineDialog: false,
        rejectReasons: "",
        isShowBtn: [true, true], //弹窗是否能显示按钮
        ordinaryBtnText: ["取消", "确认"],
      },
      // 删除弹框
      deleteForm: {
        deleteDialog: false,
        btnText: ["不删除", "删除"],
        isShowBtn: [true, true, false],
      },
      isShowDisease: false,
      auditInfoShow: "",
      contentStatus: "",
      mUrl: "",
    };
  },
  components: {
    modal,
    breadCrumb,
    contentLabelCp,
    CEditor,
    PreviewModal,
    RejectModal,
    contentAliasNames,
    Department,
    Keywords,
    SelectDisease,
    WriteDoctor,
    ContentLabel,
    AuditInfo,
    InfectiousMark,
  },
  created() {
    //获取科室
    this.queryDepartments();
    if (this.$route.query.id) {
      this.form.contentId = this.$route.query.id;
    }
    if (this.$route.query.articleType) {
      this.actionType = this.$route.query.articleType;
    }
  },
  async mounted() {
    if (window.history && window.history.pushState) {
      history.pushState(null, null, document.URL);
      window.addEventListener("popstate", this.cancel, false);
    }
    this.init();
    //获取段落
    this.getContentParagraphDictionary();
    this.$refs.contentLabelref.listTenantContentLabels();

    this.getDiseaseInfoDraftDetail();
    //获取标签
    // 点击空白地方，文章内容存到缓存里面，当刷新页面的时候能够回显
    var flag = true;
    var isjqTri = false;
    var selectRoleSetTimeout;
    $("#selectRole")
      .on("compositionstart", function () {
        flag = false;
      })
      .on("compositionend", function () {
        flag = true;
      })
      .on("input", function (e) {
        clearTimeout(selectRoleSetTimeout);
        if (!this.loading)
          selectRoleSetTimeout = setTimeout(function () {
            if (flag && !isjqTri) {
              isjqTri = true;
            } else {
              isjqTri = false;
            }
          }, 100);
      });
  },
  destroyed() {
    window.removeEventListener("popstate", this.cancel, false);
    // 移除段落缓存
    sessionStorage.removeItem("cache_articles");
  },
  methods: {
    cancel: function () {
      this.$router.push(`/wikiManage/wiki`);
      this.hopStorage();
    },
    blurEditorEvent(editor, index) {
      // 编辑文章不做临时保存操作
      /*if(this.form.contentId){
          return;
        }*/
      this.paragraphList[index].content = editor.getContent() || "";
      // var tipDom = $(
      //   '<div class="successfully" style="position: absolute; top: 0; right: 15px;color: green;">保存成功</div>'
      // );
      // let ParentElement = $(editor.editorContainer).find(".tox-toolbar__group").eq(0)
      // let subelement = ParentElement.find(".successfully")
      // // 只创建一次
      // if (subelement.length == 0) {
      //   $(editor.editorContainer).find(".tox-toolbar__group").eq(0).append(tipDom);
      // }
      // clearTimeout(this.tipTimeout);
      // this.tipTimeout = setTimeout(function () {
      //   var DeleteElement = $(".tox-toolbar__group .successfully:eq(0)");
      //   if (DeleteElement) {
      //     DeleteElement.remove()
      //   }
      // }, 500);

      var cacheArticle = this.$commonJs.getArticleDataFromCache(
        this.form.contentId
      );
      if (cacheArticle) {
        this.form.contentParagraphs = cacheArticle.contentParagraphs;
      } else {
        // 如果不存在，则新增一篇文章
        this.paragraphList.forEach((item) => {
          this.form.contentParagraphs.push({
            paragraphCode: item.code,
            paragraphName: item.desc,
            paragraphType: item.type,
            paragraphContent: item.content || "",
          });
        });
      }
      this.form.contentParagraphs[index].paragraphContent =
        editor.getContent() || "";
      this.$commonJs.setCacheArticleData(this.$commonJs.deepClone(this.form));
    },
    // 恢复段落内容
    restoreContentParagraphs({ editor, index }) {
      var article = this.$commonJs.getArticleDataFromCache(this.form.contentId);
      if (!article) {
        return;
      }
      this.$set(
        this.paragraphList[index],
        "content",
        article.contentParagraphs[index].paragraphContent
      );
    },
    //初始化获取文章标签和疾病标签
    init() {
      this.user_identity = sessionStorage.getItem("user_identity");
    },

    // 编审医生
    doctor_remoteMethod(query) {
      this.doctorList(query, "doctorOptions", "search_doctor_loading");
    },
    writeChange() {
      if (this.doctor == "") {
        this.doctorOptions = [];
      }
    },
    doctorList(query, str, loadingStr) {
      if (query !== "") {
        this[loadingStr] = true;
        request("health_cmp_listByDoctorName", {
          tenantId: this.$commonJs.getTenantId(),
          doctorName: query,
        })
          .then((res) => {
            this[str] = res;
            this[loadingStr] = false;
          })
          .catch((err) => {
            this[str] = [];
            this[loadingStr] = false;
          });
      } else {
        this[str] = [];
      }
    },
    //获取文章详情
    getDiseaseInfoDraftDetail(CB) {
      request("health_cmp_queryContentDraftById", {
        contentId: this.form.contentId,
        tenantId: this.$commonJs.getTenantId(),
      })
        .then((res) => {
          this.form.contentStatus = res.contentStatus;
          this.form.contentAuditStatus = res.contentAuditStatus;
          // 检查缓存更新时间和最新更新时间确定是否删除缓存
          var cacheArticle = this.$commonJs.getArticleDataFromCache(
            res.contentId
          );
          if (cacheArticle) {
            try {
              var cacheUpdate = new Date(
                cacheArticle.updateTime.replace(/-/g, "/")
              );
              var lastUpdate = new Date(res.updateTime.replace(/-/g, "/"));
              if (lastUpdate.getTime() > cacheUpdate.getTime()) {
                this.$commonJs.removeCacheArticleData(res.contentId);
              }
            } catch (error) {
              console.log(error);
            }
          }
          this.displayInfo(res);
          CB && CB();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 是否跟换名称
    repealclickHandler(val) {
      if (val === "one") {
        this.reset_Diseases = false;
        this.getDiseaseInfoDraftDetail();
      } else if (val === "two") {
        this.reset_Diseases = false;
      }
    },

    //反显信息
    displayInfo(res) {
      if (res.departments) {
        res.departments.map((item) => {
          if (item.departLevel == 1) {
            this.selectedDeparttId.push([item.departId]);
          } else {
            this.selectedDeparttId.push([item.parentId, item.departId]);
          }
        });
      }
      if (res.contentStatus) {
        this.contentStatus = res.contentStatus;
      }
      if (res.auditInfo) {
        this.auditInfoShow = res.auditInfo.auditStatus;
      }
      //反显疾病名称
      if (res.contentName) {
        this.form.contentName = res.contentName;
      }

      //反显别名

      if (!res.contentAliasNames) {
        this.form.contentAliasNames = [];
      } else {
        this.form.contentAliasNames = res.contentAliasNames;
      }

      if (res.diseaseInfo) {
        this.infectiousMark = res.diseaseInfo.infectiousMark;
      }
      //反显关联疾病
      this.form.contentRelations = res.contentRelations || [];
      //反显段落
      this.form.contentParagraphs = res.contentParagraphs || [];
      var cache_article = this.$commonJs.getArticleDataFromCache(res.contentId);
      if (!cache_article) {
        var isFirstAdd = this.paragraphList.length == 0;
        res.contentParagraphs &&
          res.contentParagraphs.map((item, index) => {
            if (isFirstAdd) {
              this.paragraphList.push({
                code: item.paragraphCode,
                desc: item.paragraphName,
                type: item.paragraphType,
                content: item.paragraphContent || "",
              });
            } else {
              for (var i = 0; i < this.paragraphList.length; i++) {
                if (this.paragraphList[i].code == item.paragraphCode) {
                  this.paragraphList[i].content == item.paragraphContent || "";
                  break;
                }
              }
            }
            try {
              var isEditorInited = setInterval(() => {
                var edd = this.editorList["editor" + index];
                if (edd) {
                  clearInterval(isEditorInited);
                  edd.setContent(item.paragraphContent || "");
                }
              }, 100);
            } catch (error) {
              console.log(error);
            }
          });
      }
      // 回显上次保存的标签
      this.form.contentLabels = res.contentLabels || [];
      this.showSelectedLabels();
      this.$nextTick(() => {
        //反显关键字
        this.$refs.keywordsref.keywordInfos = [];
        res.keywordInfos &&
          res.keywordInfos.map((item, index) => {
            this.$refs.keywordsref.keywordInfos.push(item.keyword);
          });
        //反显选择疾病
        if (res.contentDiseases?.length > 0) {
          res.contentDiseases.map((item) => {
            this.$refs.selectDiseaseRef.diseaseOptions.push(item);
            this.$refs.selectDiseaseRef.diseaseId = item.diseaseId;
          });
        }
      });
      this.doctorOptions = [];
      // 编审 编写医生
      if (res.doctorInfos) {
        res.doctorInfos.map((item) => {
          if (item.roleType == 2) {
            this.doctorOptions.push(item);
            this.doctor = item.docId;
          }
        });
      }
    },
    // 回显标签
    showSelectedLabels() {
      if (!this.form.contentLabels || !this.form.contentLabels.length) return;
      this.$refs.contentLabelref.listTenantContentLabels().then(() => {
        for (
          var i = 0;
          i < this.$refs.contentLabelref.contentLabels.length;
          i++
        ) {
          var group = this.$refs.contentLabelref.contentLabels[i];
          for (var j = 0; j < group.contentLabels.length; j++) {
            var label1 = group.contentLabels[j];
            for (var k = 0; k < this.form.contentLabels.length; k++) {
              var seletedLabel = this.form.contentLabels[k];
              if (label1.id == seletedLabel.id) {
                this.$set(label1, "isChecked", true);
                break;
              }
            }
          }
        }
      });
    },
    generateDiseaseId() {
      return (
        "diseaseInfoId_" +
        new Date().getTime() +
        Math.floor(Math.random() * 1000)
      );
    },
    // 删除弹框
    deleteClickHandler(val) {
      if (val === "one") {
        this.deleteForm.deleteDialog = false;
      } else if (val === "two") {
        // 清空contentID
        this.form.contentId = undefined;
        //疾病名称
        this.form.contentName = "";
        this.diseaseInfoOptions = [];
        this.selectDiseaseInfoId = "";
        //别名
        this.form.aliasName = "";
        //传染病
        this.infectiousMark = "";
        //科室
        this.selectedDeparttId = [];
        //关联疾病
        this.form.contentRelations = [];
        //段落
        this.paragraphList.map((item, index) => {
          item.content = "";
        });
        //业务标签
        this.$refs.contentLabelref.contentLabels = [];
        //关键字
        this.$refs.keywordsref.keywordInfos = [];
        this.deleteForm.deleteDialog = false;
      }
    },
    //获取科室信息
    queryDepartments() {
      let params = {
        tenantId: this.$commonJs.getTenantId(),
        contentId: this.form.contentId || "",
      };
      request("health_cmp_queryDepartsWithContentRel", params)
        .then((res) => {
          this.departmentList = res || [];
        })
        .catch((err) => {
          this.departmentList = [];
        });
    },
    //获取疾病信息
    changeDiseaseLabels(data) {
      // 关联疾病
      this.form.contentRelations = data;
    },
    //获取段落信息
    getContentParagraphDictionary() {
      request("health_cmp_getContentParagraphDictionary", {
        type: 1, // 1疾病百科，3症状百科
      })
        .then((res) => {
          this.paragraphList = res || [];
        })
        .catch((err) => {});
    },
    editorReady(data) {
      this.editorList["editor" + data.index] = data.editor;
      this.restoreContentParagraphs(data);
    },
    //选中文章标签
    checkArticleLabel(label) {
      this.$set(label, "isChecked", !label.isChecked);

      let arr = this.form.contentLabels || [];
      //判断是否存在当前项，如果存在则取消选中并从数据中删除
      if (!label.isChecked) {
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].id == label.id) {
            this.form.contentLabels.splice(i, 1);
            return false;
          }
        }
      }
      let obj = {
        labelGroupId: label.labelGroupId,
        id: label.id,
        name: label.name,
      };
      this.form.contentLabels.push(obj);
    },
    /**
     * @desc 由于某些特殊字段，无法使用vue v-model绑定操作，需要js手工赋值，故在保存，预览，提交，发布，审核文章前初始化一些表单的数据,比如上传图片，视频等信息
     * @param val  文章状态值 user端：0:第一次创建预览 1:草稿，2:发布，man端：3:保存文章，4:预览，5:通过
     * @param opt_type  user端：caogao:'草稿'，preview:'预览'，fabu:'发布'，man端： shenhe:'审核'，man-preview:'预览'，review:'保存文章'
     */
    initFormBeforeAddOrUpdate(val, opt_type) {
      //根据按钮状态修改articleStatus值 bugfix: 预览接口报异常 预览时 文章状态和草稿状态一致
      this.form.contentName = this.form.contentName.trim();
      //科室信息
      this.form.departments = [];
      this.selectedDeparttId.map((item) => {
        if (item.length == 1) {
          this.form.departments.push({
            departId: item[0],
          });
        } else {
          this.form.departments.push({
            departId: item[1],
          });
        }
      });
      this.form.bodyParts = [];
      //获取段落内容
      this.form.contentParagraphs = [];
      this.paragraphList.map((item, index) => {
        this.form.contentParagraphs.push({
          paragraphCode: item.code,
          paragraphName: item.desc,
          paragraphType: item.type,
          paragraphContent:
            this.editorList["editor" + index].getContent() || "",
        });
      });
      //关键词
      if (this.$refs.keywordsref.keywordInfos.length) {
        let arr = [];
        this.$refs.keywordsref.keywordInfos.map((item) => {
          arr.push({
            keyword: item,
            keywordType: "1",
          });
        });
        this.form.keywordInfos = arr;
      } else {
        this.form.keywordInfos = [];
      }
      this.form.doctorInfos = [];
      // 编审医生
      this.doctorOptions.map((item) => {
        if (this.doctor == item.docId) {
          item.roleType = 2;
          this.form.doctorInfos.push(item);
        }
      });
      this.form.contentStatus = this.contentStatus;
      // 传染病
      this.form.diseaseInfo = {
        infectiousMark: this.infectiousMark,
      };
      // 疾病和症状参数
      // contentType 8: 疾病百科 9: 症状百科
      this.form.contentType = Number(this.actionType);
      //选择疾病
      this.form.contentDiseases = this.$refs.selectDiseaseRef?.diseaseId
        ? [{ diseaseId: this.$refs.selectDiseaseRef.diseaseId }]
        : [];
    },
    /**
     * @desc 保存，预览，提交，发布，审核文章的检查函数
     * @param val  文章状态值 user端：0:第一次创建预览 1:草稿，2:发布，man端：3:保存文章，4:预览，5:通过
     * @param opt_type  user端：caogao:'草稿'，preview:'预览'，fabu:'发布'，man端： shenhe:'审核'，man-preview:'预览'，review:'保存文章'
     * @return true: 表单检查通过， false: ....
     */
    checkBeforeAddOrUpdate(val, opt_type) {
      // 保存文章状态不变
      if (!this.form.contentName || this.form.contentName.trim() == "") {
        this.$message.error("疾病名称不能为空");
        return false;
      }
      //保存草稿，只校验标题
      if (
        (val == 1 || val == 0) &&
        (this.form.contentAuditStatus == 1 || !this.form.contentAuditStatus)
      ) {
        return true;
      }
      if (this.infectiousMark === "") {
        this.$message.error("请确认是否为传染病");
        return false;
      }
      let isParagraphsPass = true;
      let paragraphsText = [];
      isParagraphsPass = this.form.contentParagraphs.some((item) => {
        paragraphsText.push(item.paragraphName);
        return item.paragraphContent != "";
      });
      if (!this.form.keywordInfos.length) {
        this.$message.error("关键词不能为空");
        return false;
      }
      if (!isParagraphsPass) {
        this.$message.error(paragraphsText.join(",") + "至少填写一项");
        return false;
      }
      return true;
    },
    // man-审核
    manOrUpdateDiseaseInfo(val, type) {
      this.initFormBeforeAddOrUpdate(val, type);
      if (!this.checkBeforeAddOrUpdate(val, type)) {
        return;
      }
      if (!utils.copyPictureCheck(this.form.contentParagraphs, this)) return;
      let params = this.$commonJs.deepClone(this.form);
      request("health_cmp_biz_manUpdateDiseaseBaike", params)
        .then((res) => {
          let contentIds = {
            contentId: this.form.contentId,
            tenantId: this.$commonJs.getTenantId(),
          };
          if (type == "manPreview") {
            this.articlePreview(contentIds);
          }
          // 保存
          if (type == "save") {
            this.$message.success("保存成功");
          } else if (type == "through") {
            params.auditInfo = { auditStatus: 3 };
            // 审核
            request("health_cmp_manPassContent", contentIds)
              .then((res) => {
                if (res.code === "0000" && !res.data) {
                  this.$message.error("操作失败");
                  return;
                }
                this.$message.success("审核通过");
                this.$router.push(`/wikiManage/wiki`);
                this.hopStorage();
              })
              .catch((err) => {
                this.$message.error(err.msg || "审核失败");
              });
          } else if (type == "manSubmit") {
            params.auditInfo = { auditStatus: 2 };
            request("health_cmp_manPublishContent", contentIds)
              .then((res) => {
                if (res) {
                  this.$router.push(`/wikiManage/wiki`);
                  this.hopStorage();
                }
                this.$message.success("提交成功");
              })
              .catch((err) => {
                this.$message.error(err.msg + "发布失败");
              });
          }
        })
        .catch((error) => {
          this.$message.error(error.msg || "操作失败！");
        });
    },
    hopStorage() {
      // 跳转列表页存储状态
      sessionStorage.setItem("disease", 1);
    },
    // 预览
    articlePreview(val) {
      this.dialogPreVisible = true;
      this.previewDialog = true;
      this.jumpUrl("/disease", "/preview/", val.contentId);
    },
    jumpUrl(url, type, urlId) {
      let urlAddress = "//beta-api.m.jd.com";
      let previewUrl1 = "https://cont-yf.healthjd.com/wiki/disease"; // 疾病症状预发地址
      let diseaseOnline = "https://cont.healthjd.com/wiki/disease"; // 线上疾病
      let newUrl;
      if (this.baseUrl == urlAddress) {
        newUrl = previewUrl1 + type + urlId;
      } else {
        newUrl = diseaseOnline + type + urlId;
      }
      this.mUrl = newUrl;
      getQRCode(newUrl, (url) => {
        this.qrCode = url;
        this.dialogPreVisible = true;
      });
    },
    //审核--驳回
    rejectClick() {
      this.rejectForm.rejectlineDialog = true;
    },
    rejectClickHandler(arg) {
      if (arg === "two") {
        if (this.rejectForm.rejectReasons === "") {
          this.$message.error("驳回理由不能为空");
        } else {
          //contentAuditStatus:1草稿、2待审核、3审核通过、4驳回 9撤销投稿
          request("health_cmp_manRejectContent", {
            contentId: this.form.contentId,
            tenantId: this.$commonJs.getTenantId(),
            remark: this.rejectForm.rejectReasons,
          })
            .then((res) => {
              this.rejectForm.rejectlineDialog = false;
              this.rejectForm.rejectReasons = ""; //置空驳回原因
              this.$message.success("驳回成功");
              this.hopStorage();
              this.$router.push(`/wikiManage/wiki`);
            })
            .catch((err) => {
              this.$message.error(err.msg || "发布失败");
            });
        }
      } else {
        this.rejectForm.rejectlineDialog = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/styles/article_common.scss";

.article {
  @include article_common;
  .item-video-wrap {
    border: 1px solid #c0c4cc;
  }
  :deep(.el-form-item) {
    margin-bottom: 22px;
  }
  :deep(.el-textarea__inner) {
    resize: none;
    overflow: hidden;
    overflow-y: auto;
    display: inline-block;
    margin-bottom: 45px;
    margin-right: 15px;
  }
  :deep(.el-dialog__body) {
    padding: 30px 26px 0px 26px !important;
  }

  .el-button {
    line-height: 10px;
  }

  .article_tit {
    .el-input__suffix {
      left: 100% !important;
      right: auto !important;
    }
  }
  // 表单Item样式
  .wrap .content-item .content-item-label {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
}
.finish-buttons {
  width: 307px;
  height: 32px !important;
  margin-top: 62px;
  margin-left: 61px;
}
.article .wrap .writeDoc .el-input {
  width: 645px !important;
}
</style>
